<template>
  <div class="mixing-layout min-h-screen general-app flex flex-col">
    <header class="bg-header px-4 lg:px-8 py-4 flex items-center sticky top-0 left-0 z-50">
      <div class="flex items-center sm:flex-row flex-col">
        <h1 class="text-white text-3xl font-normal text-left w-full">Mixování</h1>
      </div>
      <div class="ml-auto">
        <Button
          label="Odhlásit se"
          severity="warning"
          icon="pi pi-fw pi-sign-out"
          class="text-lg text-white"
          text
          raised
          plain
        />
      </div>
    </header>
    <div class="px-4 lg:px-8 py-6 flex flex-col flex-auto">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mixing-layout {
  background-color: #282828;
}
.bg-header {
  background-color: #141414;
}
</style>
